import TiptapUl from '@tiptap/extension-bullet-list';
import {wrappingInputRule} from '@tiptap/core';

export const inputRegex = /^\s*([-*])\s$/;

const TextStyleName = 'textStyle';

import appStyles from '../app-post-style.module.css';

export const TimeWebkitBulletListExtension = TiptapUl
    .extend({
        addKeyboardShortcuts() {
            return {
                'Mod-Shift-8': () => {
                    if (this.editor.isActive('table')) {
                        return false;
                    }
                    return this.editor.commands.toggleBulletList();
                },
            };
        },
        addInputRules() {
            let inputRule = wrappingInputRule({
                find: inputRegex,
                type: this.type,
            });

            if (this.options.keepMarks || this.options.keepAttributes) {
                inputRule = wrappingInputRule({
                    find: inputRegex,
                    type: this.type,
                    keepMarks: this.options.keepMarks,
                    keepAttributes: this.options.keepAttributes,
                    getAttributes: () => {
                        return this.editor.getAttributes(TextStyleName);
                    },
                    editor: this.editor,
                });
            }
            return [
                {
                    ...inputRule,
                    handler: (props) => {
                        if (this.editor.isActive('table')) {
                            return;
                        }
                        return inputRule.handler(props);
                    },
                },
            ];
        },
    })
    .configure({
        HTMLAttributes: {
            class: appStyles.list,
        },
    });
